export interface EstimateCostOfMechanicalWork {
  MechanicalWorkCost: number;
}

export interface MechanicalWorkItem {
  Item: string;
  check: boolean;
  Quantity: number;
  Type: string
}

export interface MechanicalCharacteristics {
  Item: string;
  check: boolean;
  Type: string
}

export interface GetAllFee {
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface MechanicalData {
  EstimateCostOfWork: EstimateCostOfMechanicalWork;
  HeatingSystemType: MechanicalCharacteristics[], 
  FuelType: MechanicalCharacteristics[],
  WorkItems: MechanicalWorkItem[];
  getAllFee: GetAllFee;
}

export const mechanicalData: MechanicalData = {
  EstimateCostOfWork: {
    MechanicalWorkCost: 0,
  },
  HeatingSystemType: [
    {
      Item: 'Hydronic',
      check: false,
      Type: 'Hydronic'
    },
    {
      Item: 'Hot Air',
      check: false,
      Type: 'Hot Air'
    }
  ],
  FuelType:[
    {
      Item: 'Gas',
      check: false,
      Type: 'Gas'
    },
    {
      Item: 'Oil',
      check: false,
      Type: 'Oil'
    },
    {
      Item: 'Electric',
      check: false,
      Type: 'Electric'
    },
    {
      Item: 'Solar',
      check: false,
      Type: 'Solar'
    },
    {
      Item: 'Other',
      check: false,
      Type: ''
    },
    
  ],
  WorkItems: [
    {
      Item: 'Fuel Oil Piping',
      check: false,
      Quantity: 1,
      Type: 'Fuel Oil Piping'
    },
    {
      Item: 'Water Heater',
      check: false,
      Quantity: 1,
      Type: 'Water Heater'
    },
    {
      Item: 'Steam Boiler',
      check: false,
      Quantity: 1,
      Type: 'Steam Boiler'
    },
    {
      Item: 'Hot Water Boiler',
      check: false,
      Quantity: 1,
      Type: 'Hot Water Boiler'
    },
    {
      Item: 'Gas Piping',
      check: false,
      Quantity: 1,
      Type: 'Gas Piping'
    },
    {
      Item: 'Fireplaces',
      check: false,
      Quantity: 1,
      Type: 'Fireplaces',
    },
    {
      Item: 'Liquid Propane Gas Tank',
      check: false,
      Quantity: 1,
      Type: 'Liquid Propane Gas Tank',
    },
  ],
  getAllFee: {
    'Certification Cost': 0,
    totalFee: 0,
    summary: [],
  },
};
